export const shouldForwardProp = (propName) => !propName.startsWith("_wms");
